import script from "./CMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CMessage.vue?vue&type=script&lang=ts&setup=true"

import "./CMessage.vue?vue&type=style&index=0&id=000aa974&scoped=true&lang=scss"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-000aa974"]])

export default __exports__